var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "product-box", attrs: { gutter: 10 } },
    [
      _vm.type === "mandatory"
        ? _vm._l(_vm.products, function (product) {
            return _c(
              "el-col",
              { key: product["product-code"], attrs: { sm: _vm.colSize } },
              [
                _c(
                  "div",
                  {
                    staticClass: "mandatory-border",
                    class: { "no-border": _vm.noBorder },
                  },
                  [
                    _c("product-info", {
                      attrs: {
                        type: _vm.type,
                        hideTitle: _vm.hideTitle,
                        hideDescription: _vm.hideDescription,
                        item: product,
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          })
        : _vm.type === "one"
        ? _vm._l(_vm.products, function (product) {
            return _c(
              "el-col",
              { key: product["product-code"], attrs: { sm: _vm.colSize } },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: product["product-code"], border: "" },
                    on: { change: _vm.onChange },
                    model: {
                      value: _vm.selectedProducts,
                      callback: function ($$v) {
                        _vm.selectedProducts = $$v
                      },
                      expression: "selectedProducts",
                    },
                  },
                  [
                    _c("product-info", {
                      attrs: {
                        type: _vm.type,
                        hideTitle: _vm.hideTitle,
                        hideDescription: _vm.hideDescription,
                        item: product,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          })
        : [
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.onChange },
                model: {
                  value: _vm.selectedProducts,
                  callback: function ($$v) {
                    _vm.selectedProducts = $$v
                  },
                  expression: "selectedProducts",
                },
              },
              _vm._l(_vm.products, function (product) {
                return _c(
                  "el-col",
                  { key: product["product-code"], attrs: { sm: _vm.colSize } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        class: { "no-border": _vm.noBorder },
                        attrs: {
                          label: product["product-code"],
                          border: !_vm.noBorder,
                        },
                      },
                      [
                        _c("product-info", {
                          attrs: {
                            type: _vm.type,
                            hideTitle: _vm.hideTitle,
                            hideDescription: _vm.hideDescription,
                            item: product,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }